import React from "react";
import { useNavigate } from "react-router-dom";

function AppFooter({ hideTerms = false }) {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <span className="copyright">
        Copyright &copy; {currentYear} Ensaras, Inc.
      </span>
      {!hideTerms && (
        <span
          className="terms"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/terms")}
        >
          TERMS AND CONDITIONS
        </span>
      )}
    </footer>
  );
}

export function MobileFooter() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  return (
    <footer className={`footer footer-mobile`}>
      <span className="copyright">
        Copyright &copy; {currentYear} Ensaras, Inc.
      </span>
      <span
        className="terms"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/terms")}
      >
        TERMS AND CONDITIONS
      </span>
    </footer>
  );
}

export default AppFooter;
